import React, { lazy, Suspense } from 'react'
import { withProtectedRoute, roles } from 'lib/auth'
import { Helmet } from 'react-helmet'
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import AppSnackbarProvider from 'components/app-snackbar-provider'
import Shell from 'components/app-shell'
import { createJrlNavigationTheme } from 'lib/junior-league-utils/jrl-navigation-theme'
import HomeOutlinedIcon from 'components/material-symbol/icons/Home'
import logo from 'images/jr-league-logo.svg'
import withJuniorLeagueAccess from 'lib/junior-league-utils/with-junior-league-access'
import { useIsMobile } from 'lib/hooks'
import { useDefaultLauncherVisibility } from 'lib/support'

const JRLManagerDashboard = lazy(() =>
  import('pages/junior-league-manager/dashboard'),
)
const RequirementsPage = lazy(() => import('components/requirements'))

const JuniorLeagueManagerRoutes = () => {
  const { path } = useRouteMatch()
  const { pathname } = useLocation()
  const isMobile = useIsMobile()

  useDefaultLauncherVisibility(!isMobile || pathname === `${path}/requirements`)

  const menuItems = [
    {
      icon: <HomeOutlinedIcon />,
      label: 'Dashboard',
      path: `${path}`,
      exact: true,
    },
  ]

  return (
    <ThemeProvider theme={createJrlNavigationTheme()}>
      <Helmet>
        <title>PGA Jr. League Management</title>
        <meta name="description" content="PGA Jr. League Management" />
        <link rel="icon" href="/jrl-favicon.ico" />
      </Helmet>
      <AppSnackbarProvider
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Shell
          logo={{ src: logo, alt: 'PGA Jr. League Logo' }}
          menuItems={menuItems}
        >
          <Suspense fallback={<LinearProgress color="secondary" />}>
            <Switch>
              <Route exact path={path} component={JRLManagerDashboard} />
              <Route
                exact
                path={`${path}/requirements`}
                component={RequirementsPage}
              />
            </Switch>
          </Suspense>
        </Shell>
      </AppSnackbarProvider>
    </ThemeProvider>
  )
}

export default withProtectedRoute(
  withJuniorLeagueAccess(JuniorLeagueManagerRoutes),
  roles.CONSUMER,
)
